// extracted by mini-css-extract-plugin
export var container = "recordCard-module--container--BMEwQ";
export var picLink = "recordCard-module--picLink--UUZ5u";
export var title = "recordCard-module--title--Q4L-c";